<script lang="ts">
	export let clickable = false;
	export let selected = false;
	export let href: string | undefined = undefined;
</script>

{#if href}
	<a
		{href}
		class="text-3xs md:text-2xs text-secondary rounded-full border bg-white px-3 font-normal leading-5"
		class:border-primary={selected}
		class:!text-primary={selected}
	>
		<slot />
	</a>
{:else}
	<button
		class="text-3xs md:text-2xs text-secondary rounded-full border bg-white px-3 font-normal leading-5"
		class:border-primary={selected}
		class:!text-primary={selected}
		class:pointer-events-none={!clickable}
		on:click
	>
		<slot />
	</button>
{/if}
